import { css, styled } from '@kitopi-com/customer-auth';

export const LoginPageContainer = styled('div')(() => {
  return css`
    display: flex;
    justify-content: center;
    align-items: center;
  `;
});
